import React, { Fragment } from 'react';

import QualityRequirement from 'components/QualityRequirement';
import { IQualityRequirement } from "types/storylet";

export interface Props {
  requirements: IQualityRequirement[],
}

export const QualityRequirements: React.FC<Props> = ({ requirements }: Props) => {
  // We have to copy the list because Array.prototype.reverse operates
  // in-place with mutation. This is the kind of thing that makes it
  // hard to defend JavaScript.
  return (
    <Fragment>
      {[...requirements]
        .reverse()
        .map((quality, i) =>
          <QualityRequirement key={i} data={quality} /> // eslint-disable-line react/no-array-index-key
        )
      }
    </Fragment>
  );
};

QualityRequirements.displayName = 'QualityRequirements';

export default QualityRequirements;

